// Knowledge-graph entity identity — Modern Vivid (coral-led) palette.
export const ENTITY_ORDER = [
  "knowledge_system",
  "school",
  "concept",
  "framework",
  "text",
  "person",
];

export const ENTITY_COLORS = {
  knowledge_system: "#ff7360",
  school: "#ffb020",
  concept: "#10a37f",
  framework: "#06b6d4",
  text: "#2563eb",
  person: "#7c3aed",
};

export const ENTITY_LABELS = {
  knowledge_system: "Knowledge System",
  school: "School",
  concept: "Concept",
  framework: "Framework",
  text: "Text",
  person: "Person",
};

// Text color that meets WCAG contrast over each node color (ink on light accents, white on dark).
export const ENTITY_TEXT = {
  knowledge_system: "#14140f",
  school: "#14140f",
  concept: "#14140f",
  framework: "#14140f",
  text: "#ffffff",
  person: "#ffffff",
};
